// Hai khung giờ để sẵn ở mọi form hẹn giờ (14/10/2026, người dùng: "để cho tôi sẵn 2 khung giờ — giờ cao điểm (ít tương tác hơn) và giờ thấp điểm
// (nhiều tương tác hơn, khuyến cáo nên chọn khung này)"). Giờ thấp điểm = giá AI DeepSeek rẻ hơn một nửa (src/shared/gio-cao-diem.ts). Bấm một khung →
// điền giờ mẫu; dòng chữ dưới luôn nói giờ đang chọn thuộc khung nào. Mọi chữ dựng bằng textContent.
import { CHU_KHUNG_CAO_DIEM, CHU_KHUNG_THAP_DIEM, chuKhungGioAi, GIO_CAO_DIEM_MAC_DINH, GIO_THAP_DIEM_MAC_DINH, khungGioAi } from "../../../src/shared/gio-cao-diem";
import { h } from "./dom";

export interface TuyChonKhungGioAi {
  /** Giờ đang chọn (HH:MM, giờ Việt Nam). */
  layGio: () => string;
  /** Điền giờ mẫu vào ô giờ của form. */
  datGio: (hhmm: string) => void;
  /** Các ngày đang chọn (1 = T2 … 7 = CN); không có = cả tuần. */
  layThu?: () => number[];
  /** Độ lệch ngẫu nhiên (phút) đang chọn. */
  layLech?: () => number;
  /** Form có múi giờ khác Việt Nam → ẩn dòng nhận xét (khung giờ tính theo giờ Việt Nam); bấm khung thì gọi `veMuiVn`. */
  laMuiVn?: () => boolean;
  veMuiVn?: () => void;
}

export function dungKhungGioAi(o: TuyChonKhungGioAi): { el: HTMLElement; capNhat: () => void } {
  const thap = h("button", { type: "button", class: "mini", "data-testid": "khung-thap-diem", title: CHU_KHUNG_THAP_DIEM }, `Giờ thấp điểm · ${GIO_THAP_DIEM_MAC_DINH} — nhiều tương tác hơn (khuyên chọn)`);
  const cao = h("button", { type: "button", class: "mini", "data-testid": "khung-cao-diem", title: CHU_KHUNG_CAO_DIEM }, `Giờ cao điểm · ${GIO_CAO_DIEM_MAC_DINH} — ít tương tác hơn`);
  const nhan = h("p", { class: "small", "data-testid": "khung-gio-nhan", role: "status" });
  const el = h("div", { class: "khung-gio-ai", "data-testid": "khung-gio-ai" }, h("div", { class: "row wrap" }, thap, cao), nhan);
  const capNhat = (): void => {
    const vn = o.laMuiVn ? o.laMuiVn() : true;
    const k = vn ? khungGioAi(o.layGio(), o.layThu?.(), o.layLech?.() ?? 0) : null;
    nhan.textContent = vn ? chuKhungGioAi(k) : "Khung giờ tính theo giờ Việt Nam — đổi múi giờ về Việt Nam để xem giờ này cao hay thấp điểm.";
    nhan.className = `small ${k === "thap_diem" ? "ok" : k === "cao_diem" || k === "hon_hop" ? "warn" : "muted"}`;
    thap.classList.toggle("pri", k === "thap_diem");
    cao.classList.toggle("pri", k === "cao_diem");
    thap.setAttribute("aria-pressed", String(k === "thap_diem"));
    cao.setAttribute("aria-pressed", String(k === "cao_diem"));
  };
  const chon = (gio: string): void => { o.veMuiVn?.(); o.datGio(gio); capNhat(); };
  thap.addEventListener("click", () => chon(GIO_THAP_DIEM_MAC_DINH));
  cao.addEventListener("click", () => chon(GIO_CAO_DIEM_MAC_DINH));
  capNhat();
  return { el, capNhat };
}
